import React from "react";
import { useStyles } from "../DeliveryCard/DeliveryCard.styles";
import { OrderLine } from "../../../pages/OrderDetailsPage/OrderDetailsTypes";
import { useTranslation } from "react-i18next";

import Currency from "../../../shared/components/currency/Currency";

interface UnavailableDeliveryProps {
  items: OrderLine[];
}

const UnavailableDelivery: React.FC<UnavailableDeliveryProps> = ({ items }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.card}>
      {/* HEADER */}
      <div className={classes.headerRow}>
        <div className={classes.deliveryIndex}>
          <span className={classes.deliveryIndexHeader}>
            {t("account.unavailable")}
          </span>
        </div>
      </div>

      {/* ITEMS LIST */}
      <div className={classes.itemsList}>
        <span className={classes.itemsListTotal}>
          {items?.length}{" "}
          {items?.length === 1 ? t("common.item") : t("common.items")}
        </span>
        {items?.map((item) => (
          <>
            <div key={item.id} className={classes.itemRow}>
              {/* LEFT — image + name */}
              <div className={classes.leftDesktop}>
                <img
                  src={item?.productVariant?.featuredAsset?.preview}
                  alt={item?.productVariant?.name}
                  className={classes.image}
                />
                <span className={classes.name}>
                  {item?.productVariant?.name}
                </span>
              </div>

              <div className={classes.leftRes}>
                <img
                  src={item?.productVariant?.featuredAsset?.preview}
                  alt={item?.productVariant?.name}
                  className={classes.image}
                />
                <div className={classes.leftResTextContainer}>
                  <span className={classes.name}>
                    {item?.productVariant?.name}
                  </span>
                  <div className={classes.leftResTotalContainer}>
                    <span className={classes.leftResQuantity}>
                      {t("account.Qty")}: {item?.quantity}
                    </span>
                    <span className={classes.leftResTotal}>
                      <Currency />
                      0.00
                    </span>
                  </div>
                </div>
              </div>

              {/* CENTER — icons + qty */}
              <div className={classes.unavailableItemsCenter}>
                <div className={classes.qty}>
                  <span className={classes.qtyLabel}>{t("account.Qty")}</span>
                  <span className={classes.qtyValue}>
                    {item.cancelledQuantity}
                  </span>
                </div>
              </div>

              {/* RIGHT — price */}
              <div className={classes.right}>
                <Currency />
                0.00
              </div>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default UnavailableDelivery;
